import React from 'react'
import Login from "./Pages/Login";
import Signup from "./Pages/Signup";
// import Layout from "./pages/Layout";
import { Route, Routes } from "react-router-dom";
import Layout from './Pages/Layout';
import { useSelector } from 'react-redux';
import HomeDashboard from './Pages/HomeDashboard';
import Meals from './Pages/Meals';
import Students from './Pages/Students';
import AddMeal from './Pages/AddMeal';
import StudentHomeDashboard from './Pages/StudentHomeDashboard';
import StudentMeals from './Pages/StudentMeals';
import AddStudent from './Pages/AddStudent';
import Resturants from './Pages/Resturants';
import AddResturants from './Pages/AddResturants';
import EditStudent from './Pages/EditStudent';
import AddNewRequest from './Pages/AddNewRequest';
import EditResturant from './Pages/EditResturant';
import MainMeals from './Pages/MainMeals';
import AddMainMeals from './Pages/AddMainMeals';
import EditMainMeal from './Pages/EditMainMeal';
import Profile from './Pages/Profile';
import Orders from './Pages/Orders';
import ChangePassword from './Pages/ChangePassword';
import StudentsNotes from './Pages/StudentsNotes';
import Notes from './Pages/Notes';
import AddStudentsNotes from './Pages/AddStudentsNotes';
import Settings from './Pages/Settings';
import EditNote from './Pages/EditNote';

function MainRoute() {
  const {userArray}=useSelector((state) => state.auth.userArray);
  console.log(userArray);
  return (
    <Routes>
      <Route path="/" element={userArray?.token ? <Layout /> : <Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
         <Route path="/dashboard" element={<Layout />}>
          
                  <Route path="/dashboard/Dashboard" element={<HomeDashboard />} />
                  <Route path="/dashboard/student-dashbord" element={<StudentHomeDashboard />} />
                  <Route path="/dashboard/profile" element={<Profile />} />
                  <Route path="/dashboard/add-student" element={<AddStudent />} />
                  <Route path="/dashboard/student-meals" element={<StudentMeals />} />
                  <Route path="/dashboard/meals" element={<Meals />} />
                  <Route path="/dashboard/notes" element={<Notes />} />
                  <Route path="/dashboard/student-notes" element={<StudentsNotes />} />
                  <Route path="/dashboard/add-student-notes" element={<AddStudentsNotes />} />
                  <Route path="/dashboard/settings" element={<Settings />} />
                  <Route path="/dashboard/main-meals" element={<MainMeals />} />
                  <Route path="/dashboard/add-main-meals" element={<AddMainMeals />} />
                  <Route path="/dashboard/meal/:id" element={<EditMainMeal />} />
                  <Route path="/dashboard/edit-note/:id" element={<EditNote />} />
                  <Route path="/dashboard/students" element={<Students />} />
                  <Route path="/dashboard/orders" element={<Orders />} />
                  <Route path="/dashboard/changePassword" element={<ChangePassword />} />
                  <Route path="/dashboard/meals/add" element={<AddMeal />} />
                  <Route path="/dashboard/resturants" element={<Resturants />} />
                  <Route path="/dashboard/add-restueant" element={<AddResturants />} />
                  <Route path="/dashboard/edit-restueant/:id" element={<EditResturant />} />
                  <Route path="/dashboard/edit-student/:id" element={<EditStudent />} />
                  <Route path="/dashboard/add-meal" element={<AddNewRequest />} />
          </Route> 



    </Routes>


  )
}

export default MainRoute
